import { useNavigate } from "react-router-dom";
import Header from "../../../layouts/Header";
import { useEffect, useState } from "react";
import { Loader, Message, Tabs } from "rsuite";
import type { Order } from "../../../my-type";
import { OrderActionType, OrderStatus, UserRole } from "../../../my-enum";
import { cancelOrder, getUserOrders } from "../../../service/OrderService";
import { useToaster } from 'rsuite';
import OrderDisplay from "../../../components/OrderDisplay";
import PageBase from "../../../components/PageBase";


export default function OrderIndex() {

  //const [step, setStep] = useState<number>(0);
  const [tabEventkey, setTabEventKey] = useState<string>("ongoing");
  const [isShowLoading, setIsShowLoading] = useState<boolean>(false);
  const [orders, setOrders] = useState<Order[]>([]);
  const navigate = useNavigate();
  const toaster = useToaster();

  const headerTitle = "我的訂單"

  useEffect(() => {

    //if (!loading && loggedIn) {
    toGetUserOrders();
    //}


  }, []);

  const toGetUserOrders = async () => {
    setIsShowLoading(true);
    let tempOrders = await getUserOrders();
    if (tempOrders && tempOrders.length > 0) {
      setOrders(tempOrders);
    }
    setIsShowLoading(false);
  }


  const messageInfoPush = (strMessage: string) => (
    <Message showIcon type="info" closable>
      {strMessage}
    </Message>
  );

  const messageErrorPush = (strMessage: string) => (
    <Message showIcon type="error" closable>
      {strMessage}
    </Message>
  );


  const onRiderClicked = async (order: Order, actionType: OrderActionType) => {
    if (actionType === OrderActionType.Cancel) {
      let cancelResult = await cancelOrder(order.orderID);
      if (cancelResult) {
        if (cancelResult.statusCode === 200) {
          toaster.push(messageInfoPush("已取消預約訂單"), { placement: 'topCenter', duration: 2000 });
          await toGetUserOrders();
          return;
        } else {
          toaster.push(messageErrorPush(cancelResult.message), { placement: 'topCenter', duration: 2000 });
        }
      }
    }

  }


  const header = <Header HeaderTitle={headerTitle} isShowRefresh={false} OnReturn={() => { navigate("/rider"); }} OnRefresh={() => { }} />;


  return (<PageBase header={header} content={<>
    <Tabs defaultActiveKey={tabEventkey} appearance="pills" onSelect={(eventKey, event) => {
      if (eventKey === "ongoing") {
        setTabEventKey("ongoing");
      } else {
        setTabEventKey("closed");
      }
    }}>
      <Tabs.Tab eventKey="ongoing" title="進行中">
        <br></br>
        {orders
          .filter(order => {
            // Only show ongoing orders whose ride time has not passed
            const ongoingStatuses = [OrderStatus.派車中, OrderStatus.已派車, OrderStatus.載客中];
            const isOngoing = ongoingStatuses.includes(order.status);
            const rideTime = new Date(order.rideTime);
            const now = new Date();
            return isOngoing && rideTime >= now;
          })
          .map((order, index) => (
            <>
              <div key={index} style={{ backgroundColor: '#f5f7fa' }}>
                <OrderDisplay order={order} isShowDetail={false} userRole={UserRole.Rider} onOrderAction={onRiderClicked} />
              </div>
              <br />
            </>
          ))}
        {/* {orders.filter(order => {
          const ongoingStatuses = [OrderStatus.派車中, OrderStatus.已派車, OrderStatus.載客中];
          const isOngoing = ongoingStatuses.includes(order.status);
          const rideTime = new Date(order.rideTime);
          const now = new Date();
          return isOngoing && rideTime >= now;
        }).length === 0 && (
            <Message showIcon type="info">
              沒有進行中的訂單
            </Message>
          )} */}
      </Tabs.Tab>

      <Tabs.Tab eventKey="closed" title="已完成">
        <br></br>
        {orders.map((order, index) => {
          if (order.status === OrderStatus.已完成) {
            return (
              <>
                <div key={index} style={{ backgroundColor: '#f5f7fa' }}>
                  <OrderDisplay order={order} isShowDetail={false} userRole={UserRole.Rider} onOrderAction={onRiderClicked} />
                </div>
                <br />
              </>)
          } else {
            return <></>
          }
        })}
        {/* {orders.filter(order => order.status === OrderStatus.已完成).length === 0 && (
          <Message showIcon type="info">
            沒有已完成的訂單
          </Message>
        )} */}
      </Tabs.Tab>

      <Tabs.Tab eventKey="cancelled" title="已取消">
        <br></br>
        {orders.map((order, index) => {
          if (order.status === OrderStatus.已取消 || order.status === OrderStatus.已退款) {
            return (<><div key={index} style={{ backgroundColor: '#f5f7fa' }}>
              <OrderDisplay order={order} isShowDetail={false} userRole={UserRole.Rider} onOrderAction={onRiderClicked} />
            </div>
              <br />
            </>)
          } else {
            return <></>
          }
        })}
        {/* {orders.filter(order => order.status === OrderStatus.已取消).length === 0 && (
          <Message showIcon type="info">
            沒有已取消的訂單
          </Message>
        )} */}
      </Tabs.Tab>



    </Tabs>
    {isShowLoading && <Loader content="正在取得資料..." />}
  </>} showSide={true} />



  )



}
